import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const LinkIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      fillOpacity={fillOpacity}
      d="m10.2066431 5.79347306c1.8670942 1.8690276 1.8414692 4.86555304.01125 6.70592444-.0034375.00375-.0075.0078125-.01125.0115624l-2.10000049 2.0999959c-1.85218795 1.8521839-4.86559495 1.851934-6.71750165 0-1.85218795-1.8518714-1.85218795-4.86561546 0-6.71748684l1.15956278-1.15956024c.30750008-.30749939.83706271-.1031248.85293772.33143685.02025.55381142.11956252 1.11021659.30281257 1.64752803.06206251.18193715.01771875.38318675-.11821878.519124l-.40896885.40896795c-.87581272.87581075-.90328147 2.30187045-.03609376 3.18624375.87575021.893092 2.31518806.8984045 3.19765704.0159375l2.10000051-2.0996834c.88096896-.88096703.87728146-2.30490175 0-3.18218129-.11565629-.11543728-.23215632-.20512461-.32315633-.26778073-.13053757-.08963992-.2110301-.23570106-.21709381-.39393672-.01237499-.33021812.10462502-.67049871.36556259-.93143568l.65793766-.65796748c.1725313-.17253091.4431876-.19371836.64325016-.05409364.22911524.15998392.44371324.33981206.64131264.5374052zm4.4042198-4.4044289c-1.8519067-1.85193388-4.86531365-1.85218388-6.7175016 0l-2.10000052 2.0999959c-.00375.00374999-.00781249.00781248-.01125.01156248-1.83018795 1.8403714-1.8558442 4.8368968.01125 6.70592436.19758778.1975843.41217552.3774021.64128141.537374.20006256.1396247.47075011.118406.64325016-.0540937l.65793767-.6579674c.26093756-.26093702.37793758-.60121759.36556259-.9314357-.00606371-.15823567-.08655624-.3042968-.21709381-.39393672-.09100002-.06265613-.20750005-.15234346-.32315634-.26778074-.87728145-.87727954-.88096896-2.30121426 0-3.18218128l2.10000052-2.09968339c.88246902-.88246704 2.32187552-.87715455 3.19765702.01593745.8671877.88437328.8397502 2.310433-.0360937 3.18624378l-.4089689.40896795c-.1359375.13593723-.1802813.33718685-.1182188.51912399.1832501.53731145.2825626 1.09371662.3028126 1.64752803.0159063.43456166.5454376.63893625.8529377.33143686l1.1595628-1.15956024c1.8522192-1.85184013 1.8522192-4.86558424.0000312-6.71745563z"
    />
  </svg>
);

LinkIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

LinkIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(16, 16),
  ...helpers.getViewBoxProperty({ width: 16, height: 16 }),
};

export default LinkIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/link.js